export function getValidCurrencies(tournament, currency) {
  return [currency, "usd", "token", "points"].filter((c) => isValidCurrency(tournament, c));
}

export function isValidCurrency(tournament, currency) {
  var validator = validators[currency] || nope;
  return validator(tournament);
}

const validators = {
  "usd": isMoneyValidCurrency,
  "token": isTokenValidCurrency,
  "points": isPointsValidCurrency
};
const nope = () => false;

export function isMoneyValidCurrency(tournament) {
  return tournament.get("money_buy_in_amount") > 0;
}

export function isTokenValidCurrency(tournament) {
  return tournament.get("token_type_id") !== undefined && tournament.get("token_type_id") !== null;
}

export function isPointsValidCurrency(tournament) {
  return tournament.get("points_buy_in_amount") > 0;
}

export function getTournamentEntryPrice(tournament) {
  var price = {};

  if (isMoneyValidCurrency(tournament)) {
    price.usd = tournament.get("money_buy_in_amount");
  }
  if (isPointsValidCurrency(tournament)) {
    price.points = tournament.get("points_buy_in_amount");
  }
  if (isTokenValidCurrency(tournament)) {
    price.token = tournament.get("token_type_id");
  }

  return price;
}
